export const THREAD_SEARCH_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'documents', label: 'With Documents' },
  { id: 'apps', label: 'Connected Apps' },
  { id: 'schedules', label: 'Schedules' },
  { id: 'triggers', label: 'Triggers' },
]

export function threadMatchesSearchFilter(thread, filter, facets = {}) {
  if (filter === 'documents') return Boolean(thread.hasDocuments || thread.documentIds?.length)
  if (filter === 'apps') {
    return Boolean(thread.hasConnectedApps || facets.connectedAppIds?.has(thread.id))
  }
  if (filter === 'schedules') return Boolean(facets.scheduledIds?.has(thread.id))
  return true
}

export function filterSearchDialogThreads(threads, searchValue, filter, facets) {
  const query = searchValue.trim().toLowerCase()
  return threads.filter((thread) => {
    if (query && !thread.title?.toLowerCase().includes(query)) return false
    return threadMatchesSearchFilter(thread, filter, facets)
  })
}
